<script>
/* global xssTokensInit */
import qs from 'qs'
export const correctUrl = window.correct_url
/**
 * @param store Reference to store use when this.$store is not defined. Required in store.js by customdbTablesColumnsByTableId() and dispatchFormItemsByFormId().
 */
export function fetchNest (url, postData, callback, errorCallback, method = 'get', headers = undefined, limit = true, listingstart = 0, allowGA = true, store) {
  if (!store) {
    store = this.$store
  }
  let myResponse = null
  const limitParams = limit ? (limit !== true ? 'filter[__listinglimit]=' + (parseInt(limit)) + (listingstart > 0 ? '&' : '') : '') + (listingstart > 0 ? 'filter[__listingstart]=' + (parseInt(listingstart)) : '') : ''
  const fetchParams = { credentials: 'include', headers: {} }
  if (postData instanceof FormData) {
    method = method === 'get' ? 'post' : method
    fetchParams.body = postData
  } else if (postData && Object.keys(postData).length !== 0) {
    method = method === 'get' ? 'post' : method
    fetchParams.body = JSON.stringify(postData)
    fetchParams.headers = {
      'Content-Type': 'text/json'
    }
  }
  if (!headers) {
    headers = {}
  }
  headers['X-Requested-With'] = 'vue'
  const parsedUrl = qs.parse(url.split('?')[1])
  if (parsedUrl.act) {
    let key = 'token_' + parsedUrl.act
    if (key.endsWith('_vue')) {
      key = key.slice(0, -4)
    }
    if (typeof xssTokensInit !== 'undefined' && xssTokensInit && xssTokensInit[key]) {
      headers['xss-token-key'] = key
      headers['xss-token-value'] = xssTokensInit[key]
    } else {
      const token = store.getters.xssTokenByName(key)
      if (token) {
        headers['xss-token-key'] = key
        headers['xss-token-value'] = token
      }
    }
  } else {
    let urlParts = url.replace(/\?.*$/, '').split('/')
    do {
      const key = 'token_' + urlParts.join('/').replace(/[^a-zA-Z0-9-]+/g, '_').replace(/(^_|_$)/, '')
      if (typeof xssTokensInit !== 'undefined' && xssTokensInit && xssTokensInit[key]) {
        headers['xss-token-key'] = key
        headers['xss-token-value'] = xssTokensInit[key]
        break
      } else {
        const token = store.getters.xssTokenByName(key)
        if (token) {
          headers['xss-token-key'] = key
          headers['xss-token-value'] = token
          break
        }
      }
      urlParts = urlParts.slice(0, urlParts.length - 1)
    } while (urlParts.length > 0)
  }
  if (headers) {
    for (const key in headers) {
      if (Object.hasOwnProperty.call(headers, key)) {
        fetchParams.headers[key] = headers[key]
      }
    }
  }
  fetchParams.method = method
  const p = fetch(correctUrl + url + (limitParams !== '' ? (url.includes('?') ? '&' : '?') + limitParams : ''), fetchParams)
  if (callback) {
    p.then(callback)
  }
  return p.then((response) => {
    myResponse = response.clone()
    if (response.status === 204) {
      return true
    }
    if (method !== 'get' && allowGA) {
      window.ajaxComplete(url, method, response.status)
    }
    if (response.status !== 200) {
      response.json().then((json) => {
        errorAjax(response, (json.message === '' && typeof json.errorsToDisplay !== 'undefined' ? json.errorsToDisplay.join(' ') : (json.displayMsg && json.error ? json.error : json.message)), json.message_img)
        if (errorCallback && typeof errorCallback === 'function') {
          errorCallback(json)
        }
      }).catch(() => { // error
        myResponse.text().then((txt) => { errorAjax(myResponse, txt) })
      })
      return null
    }

    return response.json().then((response) => {
      const requestErrorCount = myResponse.headers.get('x-request-error-count')
      if (requestErrorCount && requestErrorCount > 0) {
        console.warn(response.requestErrors ? requestErrorCount + ' PHP error(s)/warning(s) occurred in Request: \n' + response.requestErrors.join('\n') : requestErrorCount + ' error(s) occurred in Request.')
        if (window.member_role === 'superuser' || window.member_role === 'developer') {
          window.displayMessage(requestErrorCount + ' error(s) occurred in Request. Check console for more information.', 'request_errors', 'error')
        }
      }
      if (response.nextToken) {
        store.dispatch('addXssTokens', response.nextToken)
        if (typeof xssTokensInit !== 'undefined' && xssTokensInit) {
          Object.keys(response.nextToken).forEach((key) => {
          // eslint-disable-next-line
          xssTokensInit[key] = response.nextToken[key]
          })
        }
      }
      return response
    })
    // return response.json()
  }).catch((e) => { // error
    console.warn(e)
    myResponse.text().then((txt) => {
      errorAjax(myResponse, txt)
    })
    return null
  }).then(response => {
    if (response !== null && limit) {
      if (typeof response.hasMorePages === 'undefined') {
        console.warn('Limit can be used only with api/v2')
      } else if (response.hasMorePages) {
        const responseItems = JSON.parse(JSON.stringify(response.items))
        const listingStartNew = listingstart + (limit === true ? response.currentPageItems : limit)
        return this.fetchNest(url, postData, callback, errorCallback, method, headers, limit, listingStartNew).then(response2 => {
          if (response2 !== null) {
            response2.items.unshift(...responseItems)
            response2.currentPageItems = response2.items.length
            return response2
          }
        })
      }
    }
    return response
  })
}
export function errorAjax (XHR, errorMessage, errorMessageImg = null) {
  let gaCat = 'ajaxJsError'
  let keys = []
  switch (XHR.status) {
    case 401:
      if (typeof xssTokensInit !== 'undefined') {
        keys = Object.keys(xssTokensInit)
      }
      window.show_login_register_lightbox_new('no_page_refresh', keys)
      gaCat = 'ajaxJsWarning'
      window.postMessageToParent({ event: 'loginRequired' })
      break
    case 403:
      window.displayMessage(errorMessage, null, 'error', 20, errorMessageImg)
      break
    case 400:
      window.displayMessage(errorMessage || 'Some error appeared!', null, 'error', 20, errorMessageImg)
      break
    default:
      if (XHR.readyState > 0 || XHR.status > 0) {
        window.displayMessage(errorMessage || 'Some error appeared!', null, 'error', 20, errorMessageImg)
        console.log('unknown error: ', XHR.status, 'message: ', errorMessage) // ignore_console.log_warning
        const ajaxError = {
          url: XHR.url,
          readyState: XHR.readyState,
          statusCode: XHR.status,
          status: XHR.statusText,
          textContent: XHR.responseText,
          data: typeof XHR.data !== 'undefined' ? XHR.data : 'N/A'
        }
        window.logError('request', errorMessage, null, null, null, null, ajaxError)
      }
  }
  if (XHR.readyState > 0 || XHR.status > 0) {
    const pageBase = window.location.pathname.replace(/\?(.*)$/, '').replace(/^((.*)\/)?([^/]+)/, '$3')
    window.gaEvent(gaCat, XHR.status + ' ' + errorMessage + ' ' + parseActFromUrl(XHR.url), pageBase)
  }
}
export function parseActFromUrl (url) {
  if (typeof url === 'undefined') {
    return ''
  }
  const params = url.split('?')
  if (params[1]) {
    const arr = {}
    window.parse_str(params[1], arr)
    if (arr.act) {
      return arr.act
    } else {
      return ''
    }
  } else {
    return ''
  }
}
export function xssTokensInitToStore (tokens) {
  return new Promise((resolve, reject) => {
    const tokensFromStore = []
    const tokensMissing = []
    tokens.forEach(token => {
      const key = 'token_' + token.replace(/[^a-zA-Z0-9-]+/g, '_').replace(/(^_|_$)/, '')
      const tokenFromStore = this.$store.getters.xssTokenByName(key)
      if (tokenFromStore) {
        tokensFromStore.push(tokenFromStore)
      } else {
        tokensMissing.push(token)
      }
    })
    if (!tokensMissing.length) {
      return resolve(true)
    }
    this.fetchNest('api/v2/members/me/tokens?tokens=' + tokensMissing.join(','))
      .then(response => {
        if (response !== null) {
          this.$store.dispatch('addXssTokens', response.result)
          return resolve(true)
        }
        reject(new Error('Invalid response'))
      })
  })
}
export function exceptionsInit (exceptions, url, memberId) {
  const memberFromStore = this.$store.getters.memberById(memberId)
  let exceptionsMissing = []
  if (Object.hasOwnProperty.call(memberFromStore, 'exceptions')) {
    exceptions.forEach(exception => {
      if (!Object.hasOwnProperty.call(memberFromStore.exceptions, exception)) {
        exceptionsMissing.push(exception)
      }
    })
  } else {
    exceptionsMissing = exceptions
  }
  if (exceptionsMissing.length) {
    this.fetchNest(url + '?exceptions=' + exceptionsMissing.join(','))
      .then(response => {
        if (response !== null) {
          this.$store.dispatch('addMemberExceptions', { memberId: response.result.member_id, exceptions: response.result.exceptions })
        }
      })
  }
}

export function reduceErrorArrayToKeyValue (errors, initialErrors) {
  if (!initialErrors) {
    initialErrors = {}
  }
  return errors.reduce((accumulator, error) => {
    accumulator[error.identifier] = error.message
    return accumulator
  }, initialErrors)
}

export default {
  data () {
    return {
      correctUrl
    }
  },
  methods: {
    fetchNest,
    errorAjax,
    parseActFromUrl,
    xssTokensInitToStore,
    exceptionsInit,
    reduceErrorArrayToKeyValue
  }
}
</script>
